import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { trackingList } from 'src/utils/valueHTML';
import { getFontURL } from 'src/utils/getFontUrl';

const ChoiceButtonModalHTML: FC = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);
  const bgOpacity = useSelector(
    (state: RootState) => state.imageUpload.bgImageBlur
  );
  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  const btnAgain = useSelector((state: RootState) => state.buttons.btnAgain);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);

  const btnType = useSelector((state: RootState) => state.buttons.btnType);

  const backgroundDimmed = bgOpacity?.bgDimmed / 100;
  const displayValue = backgroundDimmed >= 0.01 ? backgroundDimmed : 0.7;

  const imageButtonLeftFontURL = getFontURL(btnFontFamily?.image_left_button);
  const imageButtonRightFontURL = getFontURL(btnFontFamily?.image_right_button);
  const bottomLeftFontURL = getFontURL(btnFontFamily?.bottom_left_button);
  const bottomRightFontURL = getFontURL(btnFontFamily?.bottom_right_button);
  const imageButtonFontURL = getFontURL(btnFontFamily?.image_button);

  const style = `
  @Font-face {
    font-family: 'imageLeftButton';
    src: url(${imageButtonLeftFontURL});
  }
  @Font-face {
    font-family: 'imageRightButton';
    src: url(${imageButtonRightFontURL});
  }
  @Font-face {
    font-family: 'bottomLeftButton';
    src: url(${bottomLeftFontURL});
  }
  @Font-face {
    font-family: 'bottomRightButton';
    src: url(${bottomRightFontURL});
  }
  @Font-face {
    font-family: 'imageButton';
    src: url(${imageButtonFontURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none;
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, ${displayValue});
    }

    .modal_wrapper {
      width: 100%;
      padding: 18px;

      display: flex;
      flex-direction: column;

      position: absolute;
      top: 50%;
      transform: translate(0%, -50%);
      
      border-radius: ${radius?.background}px;
      background: transparent;      

      background-repeat: no-repeat;
      background-size: cover;
      background-position: center;
    }
    
    .image_wrapper {
      width: 100%;      
      height: 100%;          
      position: relative;
      outline: none;          
      overflow: hidden;      
    }
    
    .image_wrapper img {
      width: 100%;       
      object-fit: cover;
      outline: none;
      border-radius: ${radius?.background}px;      
    }

    .image_btn_wrapper {
      position: absolute;
      width: 100%;
      bottom: 20px;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;                   
    }

    .image_btn_wrapper button {
      border: 0;
      border-radius: 4px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;                  
    }

    .image_btn_wrapper .image_btn_left {
      width: 100%;
      height: 46px;
      background-color:rgba(${btnBgColorR?.image_left_button},${
    btnBgColorG?.image_left_button
  }, ${btnBgColorB?.image_left_button}, ${
    btnBgColorA?.image_left_button
  });        
      color: ${btnColor?.image_left_button};
      font-size: ${btnFontSize?.image_left_button}rem;
      font-weight: ${btnFontWeight?.image_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.image_left_button
        )
          ? btnFontFamily?.image_left_button
          : 'imageLeftButton'
      };
      margin-right: 5px;
    }

    .image_btn_wrapper .image_btn_right {
      width: 100%;
      height: 46px;      
      background-color:rgba(${btnBgColorR?.image_right_button},${
    btnBgColorG?.image_right_button
  }, ${btnBgColorB?.image_right_button}, ${
    btnBgColorA?.image_right_button
  });        
      color: ${btnColor?.image_right_button};
      font-size: ${btnFontSize?.image_right_button}rem;
      font-weight: ${btnFontWeight?.image_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.image_right_button
        )
          ? btnFontFamily?.image_right_button
          : 'imageRightButton'
      };
      margin-left: 5px;
    }
    .image_btn_wrapper .image_btn {
      width: 100%;
      height: 46px;  
      background-color:rgba(${btnBgColorR?.image_button},${
    btnBgColorG?.image_button
  }, ${btnBgColorB?.image_button}, ${btnBgColorA?.image_button});            
      color: ${btnColor?.image_button};
      font-size: ${btnFontSize?.image_button}rem;
      font-weight: ${btnFontWeight?.image_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.image_button
        )
          ? btnFontFamily?.image_button
          : 'imageButton'
      };
    }

    .btn_wrapper {
      margin-top: 11px;
      padding: 0rem 0rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
    }

    .btn_wrapper button {
      border: 0;
      background-color: transparent;
      outline: 0;      
    }

    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.bottom_left_button}rem;
      font-weight: ${btnFontWeight?.bottom_left_button};
      color: ${btnColor?.bottom_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_left_button
        )
          ? btnFontFamily?.bottom_left_button
          : 'bottomLeftButton'
      };
      padding-left: 0.5rem;
      text-align: left;
      background-color:rgba(${btnBgColorR?.bottom_left_button},${
    btnBgColorG?.bottom_left_button
  }, ${btnBgColorB?.bottom_left_button}, ${btnBgColorA?.bottom_left_button});
    }

    .btn_wrapper .style02 {
      display:flex;
      justify-content: flex-end;
      align-items: center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.bottom_right_button}rem;
      font-weight: ${btnFontWeight?.bottom_right_button};
      color: ${btnColor?.bottom_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.bottom_right_button
        )
          ? btnFontFamily?.bottom_right_button
          : 'bottomRightButton'
      };

      text-align: right;
      background-color:rgba(${btnBgColorR?.bottom_right_button},${
    btnBgColorG?.bottom_right_button
  }, ${btnBgColorB?.bottom_right_button}, ${btnBgColorA?.bottom_right_button});
    }

    @media screen and (min-width: 540px) and (max-width: 1024px) {
      .modal_wrapper {
        width: 50%;
        margin: 0 25%;
      }         
    }
  `;

  let imageBtnWrapperHtml = '';
  if (btnType === 'single') {
    imageBtnWrapperHtml = `
    <button class="image_btn">
      ${btnText?.image_button}
    </button>
  `;
  } else {
    imageBtnWrapperHtml = `
    <button class="image_btn_left">
      ${btnText?.image_left_button}
    </button>
    <button class="image_btn_right">
      ${btnText?.image_right_button}
    </button>
  `;
  }
  const deeplink_list = JSON.stringify([
    deeplink?.image_left_button,
    deeplink?.image_right_button,
    deeplink?.image_button
  ]);

  const html = `
    <div class="root">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="modal_wrapper">
        <div class="image_wrapper">
          <img src="${bgImage?.background}" alt="insert_image" />
          <div class="image_btn_wrapper">                          
                ${imageBtnWrapperHtml}              
          </div>
        </div>         
        <div class="btn_wrapper">
          <button class="style01">
            ${btnText?.bottom_left_button}
          </button>          
          <button class="style02">
            ${btnText?.bottom_right_button}               
            <span class="material-icons" style="font-size: ${btnFontSize?.bottom_right_button +
              0.25}rem; color:${btnColor?.bottom_right_button};">
                close
            </span>          
          </button>
        </div>
      </div>
      <div id="deeplink" style="display:none;">
        ${deeplink_list}
      </div>
    </div>
  `;

  let tracking_list = '[';
  tracking_list += `"${tracking?.image_left_button?.[0]}", "${tracking?.image_right_button?.[0]}", "${tracking?.bottom_left_button?.[0]}","${tracking?.bottom_right_button?.[0]}","${tracking?.image_button?.[0]}"`;
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'CHOICE BUTTON MODAL',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function(){   
      let currentIndex = 0;            
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};

      const content = document.getElementById("deeplink").textContent;
      const link = content.replace(/\\n|\\t/g, "").trim();
      const deeplink = JSON.parse(link);
      

      $('.image_btn_left').click(function(){
        try {
          appboyBridge.logClick(tracking[0]);
          if (button1[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        }catch(err){}
        window.location = deeplink[0];        
      })

      $('.image_btn_right').click(function(){
        try {
          appboyBridge.logClick(tracking[1]);
          if (button1[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        }catch(err){}
        window.location = deeplink[1];
      })

      $('.style01').click(function() {
        try {
          appboyBridge.logClick(tracking[2]);
          if ("${btnAgain?.type}" === "attribute") {
            appboyBridge.getUser().setCustomUserAttribute("${btnAgain?.bottom_left_button}", new Date());
          }
          if ("${btnAgain?.type}" === "event") {            
            appboyBridge.logCustomEvent("${btnAgain?.bottom_left_button}");
          }
        } catch (err) {}
     
        try {
          if (button1[3].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[3].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });

      $('.style02').click(function() {
        try {
          appboyBridge.logClick(tracking[3]);
          if (button1[4].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[4].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {} 
          appboyBridge.closeMessage();        
      });

      $('.image_btn').click(function(){
        try {
          appboyBridge.logClick(tracking[4]);
          if (button1[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        }catch(err){}
        window.location = deeplink[2];
      })

    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />
        <meta
          httpEquiv="Cache-Control"
          content="no-cache, no-store, must-revalidate"
        />
        <meta httpEquiv="Expires" content="0" />
        <meta httpEquiv="Pragma" content="no-cache" />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/icon?family=Material+Icons"
        />
        {/* jquery */}
        <script id="test" src="https://code.jquery.com/jquery-3.6.0.min.js" />

        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};

export default ChoiceButtonModalHTML;
